<script setup lang="ts">
import { storeToRefs } from "pinia";

import { useCardStore } from "#/store/card";
import Blackout from "#/ui/blackout/Blackout.vue";

const props = defineProps<{
	visible: boolean;
}>();

const cardStore = useCardStore();
const { isUpSale } = storeToRefs(cardStore);

const goClose = () => {
	isUpSale.value = false;
};
</script>

<template>
	<Blackout :data="props.visible" />
	<div class="black_modal" @click="goClose"></div>
	<div class="wrapper_modal">
		<div class="card_modal">
			<slot></slot>
		</div>
	</div>
</template>

<style lang="scss" scoped>
    @use './modalWindows';
</style>
